import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {AllowedPageSizes} from '../../../../../const/constants';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const CustomerSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    const [currentLayout, setCurrentLayout]= useState("Default");
    const gridKey = "6FF0B34F-FEAB-4EB7-8EBD-2C1052DB103C";
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const childRef = useRef();
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
    };
    const statuses = [
        { id: 'A', name: 'Active' },
        { id: 'I', name: 'Inactive' },
        { id: 'D', name: 'Delete' }
    ];
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single"  />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
              
                <Scrolling mode="virtual" />
                <Column dataType="string" dataField="identityid" caption='Customer' ></Column>
                <Column dataType="string" dataField="name" caption='Name' ></Column>
                <Column dataType="string" dataField="address1" caption='Address -1' ></Column>
                <Column dataType="string" dataField="address2" caption='Address -2' ></Column>
                <Column dataType="string" dataField="city" caption='City' ></Column>
                <Column dataType="string" dataField="state" caption='State' ></Column>
                <Column dataType="string" dataField="zip" caption='Zip' ></Column>
                <Column dataType="string" dataField="country" caption='Country' ></Column>
                <Column dataType="string" dataField="telephone1" caption='Telephone1' ></Column>
                <Column dataType="string" dataField="customerStatus" caption='Status - Customer' >
                    <Lookup dataSource={statuses} displayExpr="name" valueExpr="id" visible={false} />
                </Column>
                <Column
                    dataField="userDefinedCode1"
                    caption="Code 1"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode2"
                    caption="Code 2"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode3"
                    caption="Code 3"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode4"
                    caption="Code 4"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode5"
                    caption="Code 5"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode6"
                    caption="Code 6"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode7"
                    caption="Code 7"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode8"
                    caption="Code 8"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode9"
                    caption="Code 9"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedCode10"
                    caption="Code 10"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference1"
                    caption="Reference 1"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference2"
                    caption="Reference 2"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference3"
                    caption="Reference 3"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference4"
                    caption="Reference 4"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference5"
                    caption="Reference 5"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference6"
                    caption="Reference 6"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference7"
                    caption="Reference 7"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference8"
                    caption="Reference 8"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference9"
                    caption="Reference 9"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedReference10"
                    caption="Reference 10"
                    visible={false}
                    dataType="string" />
                <Column
                    dataField="userDefinedDate1"
                    caption="Date 1"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate2"
                    caption="Date 2"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate3"
                    caption="Date 3"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate4"
                    caption="Date 4"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate5"
                    caption="Date 5"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate6"
                    caption="Date 6"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate7"
                    caption="Date 7"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate8"
                    caption="Date 8"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate9"
                    caption="Date 9"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedDate10"
                    caption="Date 10"
                    visible={false}
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="userDefinedQuantity1"
                    caption="Quantity 1"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity2"
                    caption="Quantity 2"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity3"
                    caption="Quantity 3"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity4"
                    caption="Quantity 4"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity5"
                    caption="Quantity 5"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity6"
                    caption="Quantity 6"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity7"
                    caption="Quantity 7"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity8"
                    caption="Quantity 8"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity9"
                    caption="Quantity 9"
                    visible={false}
                    dataType="number" />
                <Column
                    dataField="userDefinedQuantity10"
                    caption="Quantity 10"
                    visible={false}
                    dataType="number" />
                <Column visible={false} dataType="string" dataField="modem" caption="Modem" />
                <Column visible={false} dataType="string" dataField="modem2" caption="Modem 2" />
                <Column visible={false} dataType="string" dataField="cellPhone" caption="Cell Phone" />
                <Column visible={false} dataType="string" dataField="cellPhone2" caption="Cell Phone 2" />
                <Column visible={false} dataType="string" dataField="pager" caption="Pager" />
                <Column visible={false} dataType="string" dataField="pager2" caption="Pager 2" />
                <Column visible={false} dataType="string" dataField="email" caption="Email" />
                <Column visible={false} dataType="string" dataField="webSite" caption="Website" />
                <Column visible={false} dataType="string" dataField="webSite2" caption="Website 2" />
                <Column visible={false} dataType="string" dataField="lastUpdatedBy" caption="Last Updated By" />
                <Column visible={false} dataField="lastUpdated" caption="Last Updated" dataType="date" format="MM/dd/yyyy" />
                <Column visible={false} dataType="string" dataField="createdBy" caption="Created By" />
                <Column visible={false} dataField="creationDate" caption="Creation Date" dataType="date" format="MM/dd/yyyy" />
                <Column visible={false} dataType="string" dataField="idMasterComment" caption="Master Comment ID" />
                <Column visible={false} dataType="string" dataField="idGroup" caption="Group ID" />
                <Column visible={false} dataType="string" dataField="idSubGroup" caption="Subgroup ID" />
                <Column visible={false} dataType="string" dataField="contact" caption="Contact ID" />
                <Column visible={false} dataType="string" dataField="contactName" caption="Contact Name" />
                <Column visible={false} dataType="string" dataField="alternateName" caption="Alternate Name" />
                <Column visible={false} dataType="string" dataField="latitude" caption="Latitude" />
                <Column visible={false} dataType="string" dataField="longitude" caption="Longitude" />
                <Column visible={false} dataType="string" dataField="addressMemo" caption="Address Memo" />
                <Column visible={false} dataType="string" dataField="termsCode" caption="Terms Code" />
                <Column visible={false} dataType="string" dataField="termsDescription" caption="Terms Description" />
                
                 <Toolbar>
                 <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerSubTab);